import script from "./BPComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BPComponent.vue?vue&type=script&setup=true&lang=js"

import "./BPComponent.vue?vue&type=style&index=0&id=50e8299c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50e8299c"]])

export default __exports__